/**
 * Fasa 3 Perancangan P3-5 (pelan P3-5b): alat semakan pegawai pada halaman kes, lapisan kekangan dalam Tetapan,
 * penolakan alat itu dan nama jenis jurnalnya. Disebarkan ke dalam ms.ts.
 */

import rulesStrings from './rules-ms'

export default {
  intake: {
    rules: rulesStrings.rules,
    title: 'Alat semakan pelan',
    applicantTitle: 'Semakan pelan',
    accept: {
      button: 'Terima dengan pengecualian',
      title: 'Terima semakan yang gagal dengan pengecualian',
      intro:
        'Semakan gagal hanya atas penemuan yang boleh diterima oleh pegawai. Penerimaan meletakkan baris daftar versi ini dalam staging dan membina salinan data pelan yang dibetulkan.',
      findings: 'Penemuan yang diterima',
      noFindings: 'Tiada penemuan yang boleh diterima disenaraikan. Muat semula halaman sebelum menerima.',
      reason: 'Sebab',
      reasonHint:
        'Disimpan untuk pegawai. Pemohon hanya melihat bahawa semakan telah diterima, bukan sebab ini atau penemuannya.',
      reasonRequired: 'Berikan sebab.',
      confirm: 'Terima',
      cancel: 'Batal',
      done: 'Semakan telah diterima dengan pengecualian.',
    },
    acceptances: {
      title: 'Semakan yang diterima',
      item: 'Versi {{revision}}, diterima {{date}}',
      exceptions: 'Penemuan yang diterima: {{codes}}',
      applicant: 'Majlis telah menerima semakan pelan versi {{revision}} pada {{date}}.',
    },
    corrections: {
      title: 'Pembetulan kelas',
      item: '{{row}}: daripada {{from}} kepada {{to}}',
      when: 'Versi {{revision}}, dibetulkan {{date}}',
    },
    rows: {
      title: 'Baris daftar',
      intro: 'Tapak dan petak versi ini sebagaimana disimpan dalam daftar.',
      site: 'Tapak',
      plot: 'Petak {{number}}',
      plotRow: 'Petak (baris daftar {{id}})',
      noClass: 'Tiada kelas',
      status: {
        candidate: 'Calon (belum staging)',
        staging: 'Staging (menunggu keputusan)',
        approved: 'Diluluskan',
        rejected: 'Ditolak',
        superseded: 'Digantikan',
        withdrawn: 'Ditarik balik',
      },
      source: {
        drawing: 'Daripada pelan',
        officer: 'Dibetulkan oleh pegawai',
      },
      showOnMap: 'Tunjuk pada peta',
      correct: 'Betulkan kelas',
      olderRevision: 'Kelas dibetulkan pada versi semasa sahaja.',
    },
    correct: {
      title: 'Betulkan kelas {{row}}',
      current: 'Kelas semasa: {{class}}',
      class: 'Kelas baharu',
      choose: 'Pilih kelas…',
      classRequired: 'Pilih satu kelas.',
      unchanged: 'Pilih kelas yang berbeza daripada kelas semasa.',
      reason: 'Sebab',
      reasonHint: 'Disimpan untuk pegawai; pemohon tidak melihatnya.',
      reasonRequired: 'Berikan sebab.',
      confirm: 'Simpan kelas',
      cancel: 'Batal',
      done: 'Kelas telah dibetulkan.',
    },
    constraints: {
      title: 'Semakan kekangan',
      advisory: 'Nasihat: pertindihan di bawah memaklumkan pegawai; keputusan tetap di tangan mereka.',
      none: 'Belum ada semakan kekangan dijalankan untuk penyerahan ini.',
      run: 'Jalankan semakan kekangan',
      rerun: 'Jalankan semakan semula',
      requested: 'Semakan telah diminta. Laporannya dipaparkan di sini apabila siap.',
      queued: 'Semakan kekangan sedang menunggu giliran…',
      running: 'Semakan kekangan sedang dijalankan…',
      failed: 'Semakan kekangan tidak dapat diselesaikan: {{reason}}',
      newer: {
        queued:
          'Semakan yang lebih baharu bagi versi {{revision}} sedang menunggu giliran. Laporannya menggantikan laporan ini apabila siap.',
        running:
          'Semakan yang lebih baharu bagi versi {{revision}} sedang dijalankan. Laporannya menggantikan laporan ini apabila siap.',
        failed:
          'Semakan yang lebih baharu bagi versi {{revision}} tidak dapat diselesaikan: {{reason}} Laporan di bawah masih terpakai.',
      },
      meta: 'Versi {{revision}}, disemak {{date}}',
      packVersion: 'Jenis kekangan pek versi {{version}}',
      older: 'Laporan ini bagi versi {{revision}}; versi semasa ialah {{current}}.',
      trigger: {
        staged: 'Dijalankan selepas staging',
        on_demand: 'Dijalankan oleh pegawai',
      },
      noFindings: 'Tiada lapisan kekangan disemak.',
      layer: 'Lapisan: {{name}}',
      status: {
        overlap: 'Bertindih',
        clear: 'Bebas',
        error: 'Tidak dapat disemak',
      },
      overlap: '{{area}} ({{pct}}% daripada tapak)',
      features: 'Fitur bertindih: {{number}}',
      needsDetermination: 'Memerlukan penentuan',
      determinations: {
        title: 'Penentuan pegawai',
        open: 'Penentuan yang masih diperlukan sebelum keputusan: {{number}}',
        pending: 'Belum ditentukan',
        recorded: '{{outcome}} (ditentukan {{date}})',
        note: 'Nota: {{note}}',
        record: 'Rekod penentuan',
        change: 'Tukar penentuan',
      },
      determine: {
        title: 'Penentuan: {{kind}}',
        intro: 'Rekodkan keputusan pegawai tentang kekangan ini sebelum keputusan permohonan.',
        outcome: 'Keputusan',
        note: 'Nota',
        noteHint: 'Pilihan. Pegawai dan jabatan majlis melihatnya; pemohon tidak.',
        replaces: 'Ini menggantikan penentuan yang direkodkan pada {{date}}.',
        outcomeRequired: 'Pilih satu keputusan.',
        confirm: 'Rekod',
        cancel: 'Batal',
        done: 'Penentuan telah direkodkan.',
      },
      outcomes: {
        not_affected: 'Tidak terjejas',
        acceptable: 'Boleh diterima',
        objection: 'Bantahan',
      },
      kinds: {
        hutan_simpan: 'Hutan simpan kekal',
        ksas_tahap_1: 'Kawasan sensitif alam sekitar tahap 1',
        ksas_tahap_2: 'Kawasan sensitif alam sekitar tahap 2',
        rizab_sungai: 'Rizab sungai',
        rizab_jalan: 'Rizab jalan',
        kawasan_banjir: 'Kawasan mudah banjir',
      },
      findingErrors: {
        layer_missing: 'Lapisan yang diikat tiada lagi dalam Pustaka.',
        layer_unsupported: 'Lapisan yang diikat bukan lapisan PostgreSQL atau lapisan fitur ArcGIS.',
        server_unavailable: 'Pelayan lapisan tidak dapat dihubungi.',
        layer_srid_unknown: 'Sistem koordinat lapisan tidak diketahui.',
        query_failed: 'Pertanyaan ke atas lapisan gagal.',
        too_many_features: 'Terlalu banyak fitur bertindih dengan tapak untuk dikira.',
        address_blocked: 'Alamat lapisan tidak dibenarkan.',
        other: 'Lapisan tidak dapat disemak.',
      },
      reportErrors: {
        site_missing: 'Daftar tidak menyimpan tapak bagi versi ini.',
        superseded: 'Laporan yang lebih baharu telah menggantikannya.',
        run_failed: 'Semakan terhenti kerana ralat.',
        other: 'Semakan terhenti.',
      },
    },
    settings: {
      title: 'Lapisan kekangan',
      description:
        'Ikat setiap jenis kekangan pek kepada lapisan Pustaka yang memetakannya. Semakan dijalankan selepas staging daftar dan apabila pegawai memintanya; keputusannya bersifat nasihat.',
      kindsVersion: 'Jenis kekangan pek versi {{version}}.',
      determination: 'Memerlukan penentuan pegawai',
      advisory: 'Nasihat sahaja',
      none: 'Tiada lapisan diikat.',
      add: 'Tambah',
      addLabel: 'Lapisan untuk diikat kepada {{kind}}',
      choose: 'Pilih lapisan…',
      remove: 'Buang',
      removeLabel: 'Buang {{layer}} daripada {{kind}}',
      missingLayer: 'Lapisan yang tiada lagi ({{id}})',
      unlistedLayer: 'Lapisan {{id}}',
      loading: 'Memuatkan lapisan Pustaka…',
      loadFailed: 'Lapisan Pustaka tidak dapat dimuatkan.',
      capped: 'Hanya {{max}} lapisan pertama bagi setiap jenis disenaraikan.',
      noLayers: 'Pustaka tiada lapisan PostgreSQL atau lapisan fitur ArcGIS untuk diikat.',
      types: {
        postgresql: 'Lapisan PostgreSQL',
        arcgis_feature: 'Lapisan ArcGIS FeatureServer',
      },
      count: '{{used}} daripada {{max}} ikatan digunakan',
      tooMany: 'Paling banyak {{max}} ikatan.',
      repeated: 'Satu lapisan diikat dua kali kepada jenis yang sama.',
      unknownKind: 'Buang ikatan jenis yang tidak lagi diisytiharkan oleh pek.',
      undeclared: 'Jenis yang tidak lagi diisytiharkan oleh pek',
    },
  },
  errors: {
    ...rulesStrings.errors,
    check_not_acceptable:
      'Semakan pelan ini tidak boleh diterima: ia telah lulus, telah diterima, atau gagal kerana skalanya atau kawasan majlis.',
    register_row_not_found: 'Baris daftar itu tiada dalam versi semasa penyerahan ini.',
    class_row_changed: 'Baris daftar itu telah berubah sejak halaman dimuatkan. Muat semula halaman dan cuba lagi.',
    class_row_not_staged: 'Hanya baris daftar staging bagi versi semasa boleh dibetulkan.',
    class_path_invalid: 'Kelas itu bukan salah satu kelas guna tanah penyerahan ini.',
    class_unchanged: 'Baris itu sudah mempunyai kelas ini.',
    constraints_not_configured: 'Belum ada lapisan kekangan diikat. Pentadbir mengikatnya dalam Tetapan → Perancangan.',
    register_rows_missing: 'Versi semasa tiada baris daftar untuk disemak.',
    constraint_report_not_found: 'Laporan kekangan itu tiada dalam kes ini.',
    constraint_report_not_done: 'Laporan kekangan itu belum selesai. Muat semula halaman dan cuba lagi.',
    constraint_report_superseded:
      'Laporan kekangan yang lebih baharu telah menggantikannya. Muat semula halaman dan cuba lagi.',
    constraint_kind_unknown: 'Jenis kekangan itu tidak memerlukan penentuan dalam laporan ini.',
    constraint_report_changed:
      'Laporan kekangan itu telah berubah sejak halaman dimuatkan. Muat semula halaman dan cuba lagi.',
  },
  events: {
    plot_class_corrected: 'Kelas daftar dibetulkan',
    constraints_checked: 'Semakan kekangan direkodkan',
    rules_evaluated: 'Peraturan perancangan dinilai',
    // D-234: peristiwa peralihan yang menerima, dilabel seneutral peristiwa penerimaan selepasnya.
    transition_check_accept_exceptions: 'Semakan pelan diterima',
  },
} as const
